<div id="day-summary" *ngIf="!isRestricted">
  <div fxLayout="row">
    <div fxFlex *ngFor="let tier of tiers; let i = index">
      <div class="index-number">
        <span>{{ i + 1 }}</span>
      </div>
      <div class="tier-step">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title">{{ tier.name }}</div>
          <div fxFlex></div>
          <mat-icon *ngIf="tier.circuit" matTooltip="Circuit">loop</mat-icon>
          <button mat-icon-button	class="library-button" (click)="addTierToLibrary(tier)" matTooltip="Add To Library">
            <mat-icon>bookmark</mat-icon>
          </button>
        </div>
        <div class="content-1">
          <strong>{{ tier.notes }}</strong>
        </div>
        <div class="content-2" *ngFor="let row of tier.rows">
          <div *ngIf="row.exercise_name && row.exercise_id">
            <div *ngIf="hasVideo(row.exercise_id); else novideo">
              <a (click)="showVideo(row.exercise_id)">{{ row.exercise_name }}</a>
            </div>
            <ng-template #novideo>{{ row.exercise_name }}</ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isRestricted">
  <strong>Full details:</strong>
  <p>{{ workout.name }}</p>
</div>
